import React, { useState } from 'react';
import {
  Window,
  WindowHeader,
  WindowContent,
  Button,
  TextInput,
  Fieldset,
  Toolbar,
  Separator,
  GroupBox,
  Panel
} from 'react95';
import { ThemeProvider } from 'styled-components';
import blue from 'react95/dist/themes/blue';
import NavigatorPanel from './NavigatorPanel';

function BlueThemeBusinessForm() {
  const [formData, setFormData] = useState({
    clientName: '',
    debtCode: '',
    homeAddress: '',
    phone: '',
    workPhone: '',
    cell: '',
    fax: '',
    email: '',
    contact: '',
    drLic: '',
    ssn: '',
    acctRep: '',
    alias: '',
    comment: ''
  });

  // Navigation state for the navigator panel
  const [navigationState, setNavigationState] = useState({
    activeSection: 'debtor',
    expandedSections: ['debt', 'debtor'],
    availableFunctions: ['client-details', 'contact-information', 'debt-summary', 'payment-arrangement'],
    disabledFunctions: []
  });

  // Current client data for navigator panel
  const currentClient = formData.clientName ? {
    clientName: formData.clientName,
    debtCode: formData.debtCode,
    id: 'current-client'
  } : null;

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // Handle navigation from the navigator panel
  const handleNavigation = (navigationData) => {
    const { function: functionName, section, client } = navigationData;
    
    console.log('Navigation requested:', { functionName, section, client });
    
    // Update active section
    setNavigationState(prev => ({
      ...prev,
      activeSection: section
    }));

    // Handle specific navigation functions
    switch (functionName) {
      case 'client-details':
        // Focus on client details form
        console.log('Navigating to client details');
        break;
      case 'contact-information':
        // Focus on contact information section
        console.log('Navigating to contact information');
        break;
      case 'debt-summary':
        // Show debt summary
        console.log('Navigating to debt summary');
        break;
      case 'payment-arrangement':
        // Show payment arrangement
        console.log('Navigating to payment arrangement');
        break;
      case 'new-client':
        // Clear form for new client
        handleClear();
        break;
      default:
        console.log(`Navigation function '${functionName}' not implemented yet`);
    }
  };

  const handleSave = () => {
    console.log('Saving form data:', formData);
    alert('Form data saved!');
  };

  const handleClear = () => {
    setFormData({
      clientName: '',
      debtCode: '',
      homeAddress: '',
      phone: '',
      workPhone: '',
      cell: '',
      fax: '',
      email: '',
      contact: '',
      drLic: '',
      ssn: '',
      acctRep: '',
      alias: '',
      comment: ''
    });
  };

  return (
    <ThemeProvider theme={blue}>
      <div style={{padding: '20px', backgroundColor: '#c0c0c0', minHeight: '100vh' }}>
        <div style={{ display: 'flex', gap: '10px' }}>
          
          {/* Navigator Panel */}
          <NavigatorPanel
            currentClient={currentClient}
            onNavigate={handleNavigation}
            navigationState={navigationState}
          />

          {/* Main Application Window */}
          <Window style={{ width: '800px', height: '740px' }}>
            <WindowHeader>
              <span>🏢 Client Details - Administrator</span>
            </WindowHeader>
          
          {/* Toolbar */}
          <Toolbar style={{ justifyContent: 'flex-start' }}>
            <Button size="sm" onClick={handleSave}>
              💾 Save
            </Button>
            <Button size="sm" onClick={handleClear}>
              🗑️ Clear
            </Button>
            <Separator orientation="vertical" />
            <Button size="sm">
              📄 New
            </Button>
            <Button size="sm">
              📂 Open
            </Button>
            <Separator orientation="vertical" />
            <Button size="sm">
              🖨️ Print
            </Button>
            <Button size="sm">
              📧 Email
            </Button>
          </Toolbar>

          <WindowContent style={{ padding: '10px' }}>
            <div style={{ display: 'flex', gap: '10px', height: '100%' }}>
              
              {/* Main Form Area */}
              <div style={{ flex: 2 }}>
                <GroupBox label="Client Information">
                  <div style={{ padding: '10px' }}>
                    
                    {/* Client Name and Debt Code Row */}
                    <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
                      <div style={{ flex: 1 }}>
                        <label style={{ display: 'block', marginBottom: '5px', fontSize: '11px' }}>
                          Client Name:
                        </label>
                        <TextInput
                          value={formData.clientName}
                          onChange={(e) => handleInputChange('clientName', e.target.value)}
                          placeholder="Enter client name"
                          style={{ width: '100%' }}
                        />
                      </div>
                      <div style={{ width: '120px' }}>
                        <label style={{ display: 'block', marginBottom: '5px', fontSize: '11px' }}>
                          Debt Code:
                        </label>
                        <TextInput
                          value={formData.debtCode}
                          onChange={(e) => handleInputChange('debtCode', e.target.value)}
                          placeholder="051200002"
                          style={{ width: '100%' }}
                        />
                      </div>
                    </div>

                    {/* Address Section */}
                    <div style={{ marginBottom: '10px' }}>
                      <label style={{ display: 'block', marginBottom: '5px', fontSize: '11px' }}>
                        Home Address:
                      </label>
                      <TextInput
                        value={formData.homeAddress}
                        onChange={(e) => handleInputChange('homeAddress', e.target.value)}
                        placeholder="elmers street"
                        style={{ width: '100%' }}
                      />
                    </div>

                    {/* Contact Information Grid */}
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '10px' }}>
                      <div>
                        <label style={{ display: 'block', marginBottom: '5px', fontSize: '11px' }}>
                          Phone:
                        </label>
                        <TextInput
                          value={formData.phone}
                          onChange={(e) => handleInputChange('phone', e.target.value)}
                          style={{ width: '100%' }}
                        />
                      </div>
                      <div>
                        <label style={{ display: 'block', marginBottom: '5px', fontSize: '11px' }}>
                          Work:
                        </label>
                        <TextInput
                          value={formData.workPhone}
                          onChange={(e) => handleInputChange('workPhone', e.target.value)}
                          style={{ width: '100%' }}
                        />
                      </div>
                      <div>
                        <label style={{ display: 'block', marginBottom: '5px', fontSize: '11px' }}>
                          Cell:
                        </label>
                        <TextInput
                          value={formData.cell}
                          onChange={(e) => handleInputChange('cell', e.target.value)}
                          style={{ width: '100%' }}
                        />
                      </div>
                      <div>
                        <label style={{ display: 'block', marginBottom: '5px', fontSize: '11px' }}>
                          Fax:
                        </label>
                        <TextInput
                          value={formData.fax}
                          onChange={(e) => handleInputChange('fax', e.target.value)}
                          style={{ width: '100%' }}
                        />
                      </div>
                    </div>

                    {/* Email and Contact Row */}
                    <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
                      <div style={{ flex: 1 }}>
                        <label style={{ display: 'block', marginBottom: '5px', fontSize: '11px' }}>
                          Email:
                        </label>
                        <TextInput
                          value={formData.email}
                          onChange={(e) => handleInputChange('email', e.target.value)}
                          placeholder="p@smith.com"
                          style={{ width: '100%' }}
                        />
                      </div>
                      <div style={{ flex: 1 }}>
                        <label style={{ display: 'block', marginBottom: '5px', fontSize: '11px' }}>
                          Contact:
                        </label>
                        <TextInput
                          value={formData.contact}
                          onChange={(e) => handleInputChange('contact', e.target.value)}
                          style={{ width: '100%' }}
                        />
                      </div>
                    </div>

                    {/* License and SSN Row */}
                    <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
                      <div style={{ flex: 1 }}>
                        <label style={{ display: 'block', marginBottom: '5px', fontSize: '11px' }}>
                          Dr. Lic:
                        </label>
                        <TextInput
                          value={formData.drLic}
                          onChange={(e) => handleInputChange('drLic', e.target.value)}
                          style={{ width: '100%' }}
                        />
                      </div>
                      <div style={{ flex: 1 }}>
                        <label style={{ display: 'block', marginBottom: '5px', fontSize: '11px' }}>
                          SSN:
                        </label>
                        <TextInput
                          value={formData.ssn}
                          onChange={(e) => handleInputChange('ssn', e.target.value)}
                          style={{ width: '100%' }}
                        />
                      </div>
                      <div style={{ flex: 1 }}>
                        <label style={{ display: 'block', marginBottom: '5px', fontSize: '11px' }}>
                          Acct Rep:
                        </label>
                        <TextInput
                          value={formData.acctRep}
                          onChange={(e) => handleInputChange('acctRep', e.target.value)}
                          placeholder="Bob Hopeful"
                          style={{ width: '100%' }}
                        />
                      </div>
                    </div>

                    {/* Alias Field */}
                    <div style={{ marginBottom: '10px' }}>
                      <label style={{ display: 'block', marginBottom: '5px', fontSize: '11px' }}>
                        Alias:
                      </label>
                      <TextInput
                        value={formData.alias}
                        onChange={(e) => handleInputChange('alias', e.target.value)}
                        style={{ width: '100%' }}
                      />
                    </div>

                    {/* Comment Field */}
                    <div>
                      <label style={{ display: 'block', marginBottom: '5px', fontSize: '11px' }}>
                        Comment:
                      </label>
                      <textarea
                        value={formData.comment}
                        onChange={(e) => handleInputChange('comment', e.target.value)}
                        style={{
                          width: '100%',
                          height: '60px',
                          fontFamily: 'MS Sans Serif',
                          fontSize: '11px',
                          border: '2px inset #c0c0c0',
                          padding: '2px'
                        }}
                      />
                    </div>
                  </div>
                </GroupBox>
              </div>

              {/* Right Sidebar */}
              <div style={{ width: '200px' }}>
                <GroupBox label="Financials" style={{ marginBottom: '10px' }}>
                  <div style={{ padding: '10px', fontSize: '11px' }}>
                    <div style={{ marginBottom: '5px' }}>
                      <strong>Debt Amount:</strong> $10,000.25
                    </div>
                    <div style={{ marginBottom: '5px' }}>
                      <strong>Adjustments:</strong> $0.00
                    </div>
                    <div style={{ marginBottom: '5px' }}>
                      <strong>Legal Fees:</strong> $0.00
                    </div>
                    <div style={{ marginBottom: '5px' }}>
                      <strong>Interest:</strong> $0.00
                    </div>
                    <div style={{ marginBottom: '5px' }}>
                      <strong>Debt Fees:</strong> $0.00
                    </div>
                    <div style={{ marginBottom: '5px' }}>
                      <strong>Sub-Total:</strong> $10,500.00
                    </div>
                    <div style={{ marginBottom: '5px' }}>
                      <strong>Payments:</strong> $100.00
                    </div>
                    <div style={{ marginBottom: '10px' }}>
                      <strong>Balance:</strong> $10,400.00
                    </div>
                    <div style={{ borderTop: '1px solid #808080', paddingTop: '5px' }}>
                      <div><strong>Last Payment:</strong></div>
                      <div>18 Mar 2004 - $100.00</div>
                    </div>
                  </div>
                </GroupBox>

                <GroupBox label="Payment Arrangement">
                  <div style={{ padding: '10px', fontSize: '11px' }}>
                    <div style={{ marginBottom: '5px' }}>
                      <label>Frequency:</label>
                      <TextInput 
                        defaultValue="Fortnightly" 
                        style={{ width: '100%', marginTop: '2px' }}
                      />
                    </div>
                    <div style={{ marginBottom: '5px' }}>
                      <label>Amount:</label>
                      <TextInput 
                        defaultValue="$50.00" 
                        style={{ width: '100%', marginTop: '2px' }}
                      />
                    </div>
                    <div style={{ marginBottom: '5px' }}>
                      <label>Next Due:</label>
                      <TextInput 
                        defaultValue="4 Apr 2007" 
                        style={{ width: '100%', marginTop: '2px' }}
                      />
                    </div>
                    <div style={{ marginBottom: '5px' }}>
                      <label>Settle For Less:</label>
                      <TextInput 
                        defaultValue="N" 
                        style={{ width: '100%', marginTop: '2px' }}
                      />
                    </div>
                    <div>
                      <label>Arrears:</label>
                      <TextInput 
                        style={{ width: '100%', marginTop: '2px' }}
                      />
                    </div>
                  </div>
                </GroupBox>
              </div>
            </div>
          </WindowContent>
          </Window>
        </div>
      </div>
    </ThemeProvider>
  );
}

export default BlueThemeBusinessForm;